"use strict";
/**
 * @module *Active Selection* is when some range was selected, and a popup is
 * open to configure it, say add a link formatting, the editor looses focus,
 * so we highlight the selection with a decorator to give user feedback on what
 * text the popup is acting on.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.decorActiveSelection = void 0;
const slate_1 = require("slate");
/**
 * Returns a clipped decoration range for the supplied text-node entry when it
 * intersects the link popup's selection snapshot. Slate's `Text.decorations`
 * uses only a range's offsets — not its path — so cross-node ranges must be
 * clipped to the bounds of the current text node before being returned.
 */
const decorActiveSelection = (entry, range) => {
    const [node, path] = entry;
    if (!slate_1.Text.isText(node))
        return null;
    const textLen = node.text.length;
    const [start, end] = slate_1.Range.edges(range);
    if (slate_1.Path.compare(path, end.path) > 0)
        return null;
    if (slate_1.Path.compare(path, start.path) < 0)
        return null;
    const clipStart = slate_1.Path.equals(path, start.path) ? start.offset : 0;
    const clipEnd = slate_1.Path.equals(path, end.path) ? end.offset : textLen;
    if (clipStart >= clipEnd)
        return null;
    return {
        anchor: { path, offset: clipStart },
        focus: { path, offset: clipEnd },
        activeSelection: true,
    };
};
exports.decorActiveSelection = decorActiveSelection;
